<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <hm-table :id="$attrs['id']" :hover="false" :columns="`${6 + (created ? 1 : 0) + (cancelled ? 1 : 0)}`" min-width="800px">
    <template slot="table-head">
      <div class="hm-table__th">{{ $t('table.paymentTable.date') }}</div>
      <div v-if="created" class="hm-table__th">{{ $t('table.paymentTable.created') }}</div>
      <div v-if="cancelled" class="hm-table__th">{{ $t('table.paymentTable.cancelled') }}</div>
      <div class="hm-table__th">{{ $t('table.paymentTable.paymentMethod') }}</div>
      <div class="hm-table__th">{{ $t('table.paymentTable.description') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.paymentTable.amount') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.paymentTable.total') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.paymentTable.actions') }}</div>
    </template>
    <template slot="default">
      <template v-for="paymentProcess in payments">
        <template v-if="paymentProcess.payments.length > 1">
          <div class="hm-table__td hm-table__td--has-child-rows">{{ paymentProcess.creationBusinessDate | toDate }}</div>
          <div v-if="created" class="hm-table__td hm-table__td--has-child-rows">{{ paymentProcess.creationDate | toLocalDateTime }} // {{ paymentProcess.userName }}</div>
          <div v-if="cancelled" class="hm-table__td hm-table__td--has-child-rows">{{ paymentProcess.cancellationDate | toLocalDateTime }} // {{ paymentProcess.cancellationUserName }}</div>
          <div class="hm-table__td hm-table__td--has-child-rows"></div>
          <div class="hm-table__td hm-table__td--has-child-rows"></div>
          <div class="hm-table__td hm-table__td--has-child-rows"></div>
          <div class="hm-table__td hm-table__td--has-child-rows text-right">{{ paymentProcessTotal(paymentProcess) | toCurrency }} {{ hotelSettings.details.currency }}</div>
          <div class="hm-table__td hm-table__td--has-child-rows text-right">
            <div class="hm-table__td hm-table__td--icon">
              <v-nodes :scoped-vnodes="$scopedSlots.b1" :data="{ paymentProcess: paymentProcess }" />
              <v-nodes :scoped-vnodes="$scopedSlots.b2" :data="{ paymentProcess: paymentProcess }" />
              <v-nodes :scoped-vnodes="$scopedSlots.b3" :data="{ paymentProcess: paymentProcess }" />
            </div>
          </div>
        </template>
        <template v-for="(payment, index) in paymentProcess.payments">
          <div :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ paymentProcess.creationBusinessDate | toDate }}</div>
          <div v-if="created" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ paymentProcess.creationDate | toLocalDateTime }} // {{ paymentProcess.userName }}</div>
          <div v-if="cancelled" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ paymentProcess.cancellationDate | toLocalDateTime }} // {{ paymentProcess.cancellationUserName }}</div>
          <div v-if="payment.paymentDetail.paymentMethod === 'CreditCard'" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ $t(`PaymentSource.${payment.paymentDetail.paymentSource}`) }} // {{ $t(`PaymentMethod.${payment.paymentDetail.paymentMethod}`) }} // {{ payment.paymentDetail.creditCardDetail.type }}</div>
          <div v-else-if="payment.paymentDetail.paymentSource === 'NotApplicable'" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ $t(`PaymentMethod.${payment.paymentDetail.paymentMethod}`) }}</div>
          <div v-else :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ $t(`PaymentSource.${payment.paymentDetail.paymentSource}`) }} // {{ $t(`PaymentMethod.${payment.paymentDetail.paymentMethod}`) }}</div>
          <div v-if="!isEmpty(payment.label) && isEmpty(payment.paymentDetail.transactionReference)" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ payment.label }}</div>
          <div v-else-if="isEmpty(payment.label) && !isEmpty(payment.paymentDetail.transactionReference)" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ payment.paymentDetail.transactionReference }}</div>
          <div v-else-if="!isEmpty(payment.label) && !isEmpty(payment.paymentDetail.transactionReference)" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td">{{ payment.label }} // {{ payment.paymentDetail.transactionReference }}</div>
          <div v-else :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td"></div>
          <div :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td  text-right">{{ payment.amount | toCurrency }} {{ payment.currency }}</div>
          <div v-if="paymentProcess.payments.length > 1" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td"></div>
          <div v-else :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td  text-right">{{ payment.amount | toCurrency }} {{ payment.currency }}</div>
          <div v-if="paymentProcess.payments.length > 1" :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td"></div>
          <div v-else :class="[{'hm-table__td--has-child-rows': index+1 < paymentProcess.payments.length}]" class="hm-table__td text-right">
            <div class="hm-table__td hm-table__td--icon">
              <v-nodes :scoped-vnodes="$scopedSlots.b1" :data="{ paymentProcess: paymentProcess }" />
              <v-nodes :scoped-vnodes="$scopedSlots.b2" :data="{ paymentProcess: paymentProcess }" />
              <v-nodes :scoped-vnodes="$scopedSlots.b3" :data="{ paymentProcess: paymentProcess }" />
            </div>
          </div>
        </template>
      </template>
    </template>
  </hm-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last, sumBy } from 'lodash';

export default {
  name: 'PaymentTable',

  mixins: [HotelmeisterMixin],

  props: {
    payments: {
      type: Array,
      required: true,
      default: () => [],
    },
    created: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancelled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
  },

  methods: {
    paymentProcessTotal(paymentProcess) {
      return sumBy(paymentProcess.payments, it => it.amount);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/PaymentTable.vue